import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom'
import BuniChatWidget from './components/BuniChat';
import { ScrollToTop } from './components/ScrollToTop';
import { SiteFooter, SiteHeader, ScrollManager } from './components/SiteChrome';
import { ThemeProvider } from './contexts/ThemeContext';
import { ChatProvider } from './contexts/ChatContext';

import withTracker from './components/with-tracker';

import Home from './pages/home';
import Posts from './pages/posts';
import Post from './pages/post';
import About from './pages/about';
import NotFound from './pages/404';

function AppContent() {
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <Router>
        <ScrollManager />
        <a
          href="#main"
          className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded-sm focus:bg-signal focus:px-4 focus:py-2 focus:text-sm focus:text-primary-foreground"
        >
          Skip to content
        </a>
        <SiteHeader />
        <main id="main" className="flex-1">
          <Routes>
            <Route path="/" element={React.createElement(withTracker(Home))} />
            <Route path="/posts" element={React.createElement(withTracker(Posts))} />
            <Route path="/posts/:slug" element={React.createElement(withTracker(Post))} />
            <Route path="/about" element={React.createElement(withTracker(About))} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <SiteFooter />
        <ScrollToTop />
      </Router>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <ChatProvider>
        <AppContent />
        <BuniChatWidget />
      </ChatProvider>
    </ThemeProvider>
  );
}

export default App;
